import * as ActionTypes from "../action-types";
import Http from "../../Http";

export const defaultDossier = {
  isLoading: true,
  isLoadingPayment: false,
  dossier: {
    number: null,
    balance: null,
    specification: {},
    paymentPlay: {},
    client: {},
    debtor: {},
    status: {},
    plaintiff: {},
  },
  paymentPlan: {
    schedule: [],
  },
  invoices: [],
  transactions: [],
  cantPay: false,
  faqs: [],
  isSubscribed: false,
  settings: {},
  dossierList: [],
  birthDate: null,
};

const initialState = {
  isAuthenticated: false,
  tokenExpired: false,
  data: defaultDossier,
};

const setIsSubscribed = (state, payload) => {
  return { ...state, data: { ...state.data, isSubscribed: payload } };
};

const setDossierList = (state, payload) => {
  return { ...state, data: { ...state.data, dossierList: payload } };
};

const setDateOfBirth = (state, payload) => {
  return { ...state, data: { ...state.data, birthDate: payload } };
};

const setLoading = (state, payload) => {
  return { ...state, data: { ...state.data, isLoading: payload } };
};

const setPaymentLoading = (state, payload) => {
  return { ...state, data: { ...state.data, isLoadingPayment: payload } };
};

const setDossier = (state, payload) => {
  return { ...state, data: { ...state.data, ...payload } };
};

const updateDossier = (state, payload) => {
  return {
    ...state,
    data: { ...state.data, dossier: { ...state.data.dossier, ...payload } },
  };
};

const updateDebtorEmail = (state, payload) => {
  return {
    ...state,
    data: {
      ...state.data,
      dossier: {
        ...state.data.dossier,
        debtor: { ...state.data.dossier.debtor, email: payload },
      },
    },
  };
};

const setFaqs = (state, payload) => {
  return { ...state, data: { ...state.data, faqs: [...payload] } };
};

const setInvoices = (state, payload) => {
  return { ...state, data: { ...state.data, invoices: [...payload] } };
};

const authDossierLogin = (state, payload) => {
  if (!payload || !payload.access_token) {
    return state;
  }
  const { access_token: AccessToken } = payload;

  localStorage.setItem("access_token_time", Math.floor(Date.now() / 1000));
  localStorage.setItem("access_token", AccessToken);
  Http.defaults.headers.common.Authorization = `Bearer ${AccessToken}`;

  return { ...state, isAuthenticated: true };
};

const checkAuth = state => {
  if (state.isAuthenticated) {
    Http.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
      "access_token"
    )}`;
  }

  return { ...state, isAuthenticated: !!localStorage.getItem("access_token") };
};

const logout = (state, payload) => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("access_token_time");

  return {
    ...state,
    isAuthenticated: false,
    tokenExpired: payload.tokenExpired,
    data: {
      ...defaultDossier,
      dossier: { ...defaultDossier.dossier, number: payload.dossierNumber },
    },
  };
};

const handlers = {
  [ActionTypes.SET_DOSSIER]: (state, payload) => setDossier(state, payload),
  [ActionTypes.UPDATE_DOSSIER]: (state, payload) =>
    updateDossier(state, payload),
  [ActionTypes.AUTH_DOSSIER_LOGIN]: (state, payload) =>
    authDossierLogin(state, payload),
  [ActionTypes.AUTH_DOSSIER_CHECK]: (state, payload) => checkAuth(state),
  [ActionTypes.AUTH_DOSSIER_LOGOUT]: (state, payload) => logout(state, payload),
  [ActionTypes.SET_DOSSIER_LOADING]: (state, payload) =>
    setLoading(state, payload),
  [ActionTypes.SET_INVOICES]: (state, payload) => setInvoices(state, payload),
  [ActionTypes.SET_PAYMENT_LOADING]: (state, payload) =>
    setPaymentLoading(state, payload),
  [ActionTypes.SET_FAQS]: (state, payload) => setFaqs(state, payload),
  [ActionTypes.SET_IS_SUBSCRIBED]: (state, payload) =>
    setIsSubscribed(state, payload),
  [ActionTypes.UPDATE_DEBTOR_EMAIL]: (state, payload) =>
    updateDebtorEmail(state, payload),
  [ActionTypes.SET_DOSSIER_LIST]: (state, payload) =>
    setDossierList(state, payload),
  [ActionTypes.SET_DATE_OF_BIRTH]: (state, payload) =>
    setDateOfBirth(state, payload),
};

const dossierReducer = (state = initialState, { type, payload = null }) => {
  if (handlers.hasOwnProperty(type)) {
    return handlers[type](state, payload);
  }

  return state;
};

export default dossierReducer;
